import { NgModule } from '@angular/core';
import { ThemeSwitcherModule } from './components/theme-switcher/theme-switcher.module';

@NgModule({
  imports: [ThemeSwitcherModule],
  exports: [ThemeSwitcherModule],
})
export class ThemeModule {}
